import router from '@/router';
import store from '@/store'
// Vue 2.7+ tem Composition API nativa, não precisa do plugin
// import { computed } from 'vue'; // Se precisar usar computed function
import { createAcl, defineAclRules } from 'vue-simple-acl/dist/vue-simple-acl.vue2';
import listPermissions from '@/enums/listPermissionsAcl';

// Captura usuário Logado
var user = store.getters.user;

const rules = () => defineAclRules((setRule) => {

    // Define regras
    for (let item in listPermissions) { // Todas permissions
        setRule(listPermissions[item], (user) => user.permissions.includes(listPermissions[item]));
    }
});

const simpleAcl = createAcl({
    user,
    rules,
    router,
});

export default simpleAcl;
